/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_OwnInputs */



/**
* | output |
* | --- |
* | "Our own Discord server" |
*
* @param {Tournament_Wiz_Home_OwnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_own = /** @type {((inputs?: Tournament_Wiz_Home_OwnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_OwnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notre propre serveur Discord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuestro propio servidor de Discord")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nosso próprio servidor do Discord")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nostro server Discord")
	return /** @type {LocalizedString} */ ("Our own Discord server")
});